import {ShopCreaturePanel} from "@/scenes.ui/shop-creature-panel";
import {Tr} from "@/i18n/i18n";

export class MythHeroPanel extends ShopCreaturePanel {

    protected getButtonText(): string {
        return Tr('2.exch');
    }
}